import styles from './Empty.module.scss'

type EmptyProps = {
  image?: React.ReactNode
  title: string
  description?: string
  button?: React.ReactNode
}

const Empty = (props: EmptyProps) => (
  <div className={styles.empty}>
    {props.image ? <span className={styles.image}>{props.image}</span> : null}
    <div className={styles.container}>
      <div className={styles.content}>
        <p className={styles.title}>{props.title}</p>
        {props.description ? (
          <p className={styles.description}>{props.description}</p>
        ) : null}
      </div>
      {props.button}
    </div>
  </div>
)

export default Empty
